import allImgPaths from "assets/images";

const LogisticsViewMode = ({ data, index, tab = null, remove, edit, add }: any) => {
    // console.log({ viewData: data })

    const selectedValues = (dataArr: any = []) => {
        return dataArr
            .filter((facility: any) => facility.selected)
            .map((facility: any) => facility.listName)
            .join(', ');
    }

    const getLabelName = (key: any) => {
        let labelName;
        if (key == 'capacity') labelName = 'Capacity'
        if (key == 'count') labelName = 'Count'
    }

    const removeData = () => {
        if (tab?.name == 'legal_compliance_sustainability') {
            remove(index, tab.type)
        } else {
            remove(index)
        }
    }

    const editData = () => {
        if (tab?.name == 'legal_compliance_sustainability') {
            edit(index, tab.type)
        } else {
            edit(index)
        }
    }

    const addMore = () => {
        if (tab?.name == 'legal_compliance_sustainability') {
            add(tab.type)
        } else {
            add()
        }
    }

    return (
        <div className="">
            {
                data?.isSaved &&
                <>
                    <div className="mb-4 flex justify-between items-center">
                        {
                            data?.type &&
                            <p className="text-[#101828] font-interSemiBold">{typeof data?.type == 'string' ? data?.type : data?.type?.label}</p>
                        }

                        {
                            !data?.type &&
                            <p className="text-[#101828] font-interSemiBold">N/A</p>
                        }
                        <div className="flex items-center gap-x-2">
                            <img onClick={editData} className="w-6 h-6 cursor-pointer hover:bg-[#e8e6fe] rounded p-0.5" src={allImgPaths.EditTextIcon} alt="" />
                            {
                                index != 0 &&
                                <img onClick={removeData} className="absolute -top-4 -right-4 border border-[#F2F4F7] rounded-full p-1 cursor-pointer bg-white hover:bg-[#f2f4f7]" src={allImgPaths.crossIcon} alt="" />
                            }
                        </div>
                    </div>

                    <div className="">
                        {
                            data?.security?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Requirements : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.security) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.permits?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Needed : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.permits) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.insurances?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Needed : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.insurances) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.healths?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Needed : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.healths) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.sustainability?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Needed : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.sustainability) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.accessibility?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Requirements : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.accessibility) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.features?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Features : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.features) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.cuisineTypes?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Cuisine : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.cuisineTypes) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.dietaryRestrictions?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Restrictions : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.dietaryRestrictions) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            data?.beverageServices?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Beverage Service : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.beverageServices) || 'N/A'}
                                </span>
                            </div>
                        }
                        {
                            (data?.capacity || data?.count) &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">
                                    {data?.capacity && 'Capacity :'}
                                    {data?.count && 'Count :'}
                                </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {data?.capacity || data?.count}
                                </span>
                            </div>
                        }
                        {
                            data?.facilities?.length > 0 &&
                            <div className="mb-3 last:mb-0">
                                <span className="text-[#667085] font-interRegular text-sm">Facilities : </span>
                                <span className="text-sm text-[#000] font-interSemiBold">
                                    {selectedValues(data.facilities) || 'N/A'}
                                </span>
                            </div>
                        }
                        <div className="mb-3 last:mb-0">
                            <span className="text-[#667085] font-interRegular text-sm">Use For : </span>
                            <span className="text-sm text-[#000] font-interSemiBold">{data?.use_for}</span>
                        </div>
                        <div className="">
                            <p>{data?.special_requirements}</p>
                        </div>
                    </div>
                </>
            }
            {
                !data?.isSaved &&
                <>
                    <div className="flex flex-col justify-center text-center">
                        <img className="w-[200px] pb-5 mx-auto" src={allImgPaths.logisticsEmptyState} alt="" />
                        <p className="text-base text-[#344054] font-interSemiBold">No requirements found</p>
                        <p className="text-base text-[#344054] font-interRegular">Add new to enter your requirements</p>
                    </div>
                    <div className='flex justify-center mt-4'>
                        <button onClick={addMore} className="border border-[#1E0AF5] hover:bg-[#E8E6FE] rounded-lg flex items-center gap-x-2 py-2.5 px-3.5 mb-6 mt-1.5" type="button">
                            <img src={allImgPaths.plusCircleBlueIcon} alt='' />
                            <span className='text-[#1E0AF5] text-sm font-interSemiBold'>
                                Add New
                            </span>
                        </button>
                    </div>
                </>
            }
        </div>
    );
}

export default LogisticsViewMode;
